<div  [style]="{'min-height': '41px'}">
  <ng-container *ngIf="oskSubscriptions$ | async as subscriptionList">
    <div class="border-1 border-bluegray-500 border-round-md flex flex-wrap gap-3 p-2 align-items-center w-max max-w-full ml-auto" [style]="{'min-height': '41px'}">
      <p class="text-gray-500 font-medium">{{ subscriptionList.length > 0 ?  'Dostępne abonamenty' : 'Brak dostępnych abonamentów'}}</p>
        <div class="flex flex-wrap gap-2 align-items-center ml-auto">
            <app-subscription-tag
              *ngFor="let subscription of subscriptionList"
              [bgColor]="subscription.bgColor"
              [fgColor]="subscription.fgColor"
              [planName]="subscription.planName"
              [available]="subscription.availablePlans.toString()"
            ></app-subscription-tag>
        </div>
    </div>
  </ng-container>
</div>

<fas-service-dynamic-table class="table-height"
  [columns]="columns"
  [dataMode]="'server'"
  [dataService]="fetchOskStudentsList"
  [dateFormat]="'dd.MM.yyyy'"
  [columnTemplates]="{
    subscriptionPlanStatusTemp: subscriptionPlanStatusTempRef,
    subscriptionPlanTemp: subscriptionPlanTempRef,
    internalExamStatusTemp: internalExamStatusTempRef,
    subscriptionActionsTemp: subscriptionActionsTempRef
  }"
  [showGlobalSearch]="true"
  (dataLoaded)="studentListLoaded($event)"
  [resetTrigger]="resetTrigger.asObservable()"
  [refreshCurrentPage]="refreshCurrentPage.asObservable()"
>
  <ng-template #subscriptionPlanTempRef let-row>
    <app-subscription-tag
      [bgColor]="row.oskPlatformSubscriptionPlan.bgColor"
      [fgColor]="row.oskPlatformSubscriptionPlan.fgColor"
      [planName]="row.oskPlatformSubscriptionPlan.planName"
    ></app-subscription-tag>
  </ng-template>
  <ng-template #subscriptionPlanStatusTempRef let-row>
    @if(row.validTo===null){
      Użytkownik nie aktywował konta
    }@else {
      <div [style.color]="getStatus(row.validTo).color">
        {{ getStatus(row.validTo).status }}
      </div>
    }
  </ng-template>
  <ng-template #internalExamStatusTempRef let-row>
    <div
      *ngIf="hasInternalExamResult(row); else noInternalExamResult"
      class="internal-exam-summary"
      [class.internal-exam-summary--passed]="isInternalExamPassed(row.internalExamResult)"
      [class.internal-exam-summary--failed]="!isInternalExamPassed(row.internalExamResult)"
      [pTooltip]="getInternalExamStatusTooltip(row)"
      tooltipPosition="top">
      <span class="internal-exam-summary__icon">
        <i class="pi" [ngClass]="getInternalExamSourceIcon(row.internalExamSource)"></i>
      </span>
      <span>{{ isInternalExamPassed(row.internalExamResult) ? 'zaliczony' : 'niezaliczony' }}</span>
    </div>
    <ng-template #noInternalExamResult></ng-template>
  </ng-template>
  <ng-template #subscriptionActionsTempRef let-row let-rowIndex="rowIndex">
    <p-menu
      #actionsMenu
      [model]="actionMenuItems"
      [popup]="true"
      appendTo="body">
    </p-menu>
    <button
      class="pi pi-ellipsis-v cursor-pointer text-center appear transparent-button"
      pTooltip="Akcje"
      tooltipPosition="bottom"
      (click)="openActionsMenu($event, row, rowIndex, actionsMenu)" data-clarity-unmask="true">
    </button>
  </ng-template>
</fas-service-dynamic-table>


